import { formatDistance, parseJSON } from "date-fns";
export function formatUpdateDescription(timeVar) {
  return `${formatDistance(parseJSON(timeVar), new Date())} ago`;
}
